import { call, put, takeLatest, select } from 'redux-saga/effects';
import { isEmpty } from 'lodash';
import {
  actionTypes,
  fetchBankAccountsFailure,
  fetchBankAccountsSuccess,
  setBankAccountsDataPresented,
} from 'modules/Profile/redux/bankAccounts/actions';
import { russianBankAccountsIsDataPresented } from 'modules/Profile/components/BankAccounts/selectors';
import { getBankAccounts } from 'modules/Profile/services/API/getBankAccounts';

function* getData({ payload }) {
  const response = yield call(getBankAccounts, payload);
  if (response.isOk) {
    const isFirstRequest = yield select(russianBankAccountsIsDataPresented);
    if (isFirstRequest === null) {
      const isDataPresented = !isEmpty(response.data.content);
      yield put(setBankAccountsDataPresented(isDataPresented));
    }
    return yield put(fetchBankAccountsSuccess(response.data));
  }
  return yield put(fetchBankAccountsFailure(response.error));
}

export default function* bankAccountsSaga() {
  yield takeLatest(actionTypes.BANK_ACCOUNTS_REQUEST_START, getData);
}
